import quotationsReducer from './quotations.reducers';

export default {

  'quotationsReducer': quotationsReducer,
  // 'authorityReducer': {
  // },
}